import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { AnimatedCollection, AnimatedCollectionType } from './AnimatedCollection';

export interface IconGridLayoutWidgetProps<T> {
  gap: number;
  cols: number;
  elements: T[];
  generateElement: (element: T) => React.JSX.Element;
}

export function IconGridLayoutWidget<T>(props: IconGridLayoutWidgetProps<T>) {
  let result = React.useMemo(() => {
    return css`
      width: 200px;
      aspect-ratio: 1/1;
      display: flex;
      align-items: stretch;
      justify-content: stretch;

      @media (max-width: 700px) {
        flex-basis: calc(100% / ${props.cols} - ${props.gap}px / ${props.cols} * (${props.cols - 1}));
      }
    `;
  }, [props.gap, props.cols]);

  return (
    <S.List cols={props.cols} gap={props.gap}>
      <AnimatedCollection<T>
        children={props.elements}
        type={AnimatedCollectionType.FADE_IN}
        generate_inner={(u) => {
          return props.generateElement(u);
        }}
        generate_outer_class={() => result}
      />
    </S.List>
  );
}
namespace S {
  export const List = styled.div<{ gap: number; cols: number }>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: ${(p) => p.gap}px;
    row-gap: ${(p) => p.gap}px;
  `;
}
